import {
  resolveCurriculumVoiceTrackId,
  type CurriculumVoiceTrackId
} from "@/audio/curriculum-catalog";
import type {
  ActivityHostActionEvent,
  ActivityHostBridgeEvents
} from "@/features/activity-host";
import type { EventBridge } from "@/game/core/event-bridge";

export interface EnglishActivityNarrationPlayCommand<TAction> {
  readonly type: "play-activity-narration";
  readonly audioKey: CurriculumVoiceTrackId;
  readonly caption: string;
  readonly playbackRequest: number;
  readonly endedEvent: ActivityHostActionEvent<TAction>;
  readonly unavailableEvent: ActivityHostActionEvent<TAction>;
}

export interface EnglishActivityNarrationStopCommand {
  readonly type: "stop-activity-narration";
  readonly audioKey: CurriculumVoiceTrackId;
  readonly playbackRequest: number;
}

export type EnglishActivityNarrationCommand<TAction> =
  | EnglishActivityNarrationPlayCommand<TAction>
  | EnglishActivityNarrationStopCommand;

export type EnglishActivityHostBridgeEvents<TAction> =
  ActivityHostBridgeEvents<TAction> & {
    readonly narration: EnglishActivityNarrationCommand<TAction>;
  };

export type EnglishActivityHostBridge<TAction> = EventBridge<
  EnglishActivityHostBridgeEvents<TAction>
>;

export function requireEnglishActivityAudioKey(
  path: string
): CurriculumVoiceTrackId {
  const audioKey = resolveCurriculumVoiceTrackId(path);

  if (audioKey === null) {
    throw new Error("Missing English activity audio catalog key for " + path);
  }

  return audioKey;
}
